module.exports = require("@deck.gl/layers");